import { useCallback } from 'react';
import { Direction } from '../utils/spatialNavigation';

export default function useOnDownArrowPress(callback) {
  return useCallback(
    (direction) => {
      if (direction === Direction.DOWN && callback) {
        callback();
        return false;
      }

      return true;
    },
    [callback],
  );
}
